import { Footer } from 'components/PageFooter';
import { Header } from 'components/PageLayout/Header';
import styles from './styles.module.scss';

import { FC, HTMLAttributes, ReactNode } from 'react';
import cx from 'clsx';

type PageLayoutProps = HTMLAttributes<HTMLElement> & {
  header?: ReactNode; // Provide a custom header. If not provided then the default is used.
  footer?: ReactNode; // Provide a custom footer. If not provided then the default is used.
  hideHeader?: boolean;
  hideFooter?: boolean;
  showBackground?: boolean;
  fullWidth?: boolean;
  // Apply your own main class. If truthy, then the auto-applied max-width and padding is NOT applied to the main body.
  customMainClass?: string;
  forceStandardClasses?: boolean;
}

export const PageLayout: FC<PageLayoutProps> = (props) => {
  const {
    header,
    children,
    footer,
    className,
    hideHeader,
    hideFooter,
    customMainClass,
    forceStandardClasses,
    showBackground,
    fullWidth,
    ...passThroughProps
  } = props;
  const usingCustomHeader = !hideHeader && !!header; // The parent component will have to provide their own padding above main

  const mainClass = cx({
      [styles.main]: forceStandardClasses || !customMainClass,
      [styles.belowHeader]: forceStandardClasses || (!customMainClass && !usingCustomHeader),
      [styles.fullWidth]: fullWidth,
    },
    customMainClass
  );

  return (
    <div className={cx(styles.wrapper, { [styles.background] : showBackground }, className)} {...passThroughProps}>
      {!hideHeader && (header || <Header />)}
      {/*Browser reader mode functionality looks for the presence of the <main> element*/}
      <main className={mainClass}>
        {children}
      </main>
      {!hideFooter && (footer || <Footer />)}
    </div>
  );
};
